module.exports = __webpack_public_path__ + "img/digital-ads-performance-dark.e740568c.svg";